import React, { useState, useRef, useEffect } from "react";
import { Container, Row, Col, Button, Form } from "react-bootstrap";
import { AnimatePresence, motion } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../assets/images/logo.png";
import lock from "../../assets/images/lock.png";
import mail from "../../assets/images/mail.png";
import star from "../../assets/images/Mask.png";
import right from "../../assets/images/right.png";
import ApiService from "../../services/ApiService";
import { toast } from "react-toastify";
import decoration from "../../assets/images/decoration.png";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import AuthGuard from "../../components/AuthGuard";
import { useTranslation } from "react-i18next";

const ForgotPassword = () => {
  const [step, setStep] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const inputsRef = useRef([]);
  const [resendCooldown, setResendCooldown] = useState(0);

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [companyData, setCompanyData] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    if (step === 2 && inputsRef.current[0]) {
      inputsRef.current[0].focus();
    }
  }, [step]);

  const handleOtpChange = (e, index) => {
    const val = e.target.value;
    if (val === "" || /^\d$/.test(val)) {
      const newOtp = [...otp];
      newOtp[index] = val;
      setOtp(newOtp);
      if (val && index < 5) inputsRef.current[index + 1].focus();
    }
  };

  const handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  const submitEmail = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error("Please enter your email.");
      return;
    }
    setIsLoading(true);
    try {
      const res = await ApiService.request({
        method: "POST",
        url: "/company/forgotPassword",
        data: { email },
      });
      if (res.data.status) {
        toast.success("OTP sent to your email.");
        setStep(2);
        setResendCooldown(60);
        setCompanyData(res.data.data.company)
      } else {
        toast.error(res.data.message || "Failed to send OTP.");
      }
    } catch {
      toast.error("Something went wrong.");
    }
    setIsLoading(false);
  };

  const resendOtp = async () => {
    if (resendCooldown > 0) return;
    try {
      const res = await ApiService.request({
        method: "POST",
        url: "/company/resendOTP",
        data: { company_id: companyData?._id, send_for: "forgot" },
      });
      if (res.data.status) {
        toast.success("OTP resent.");
        setResendCooldown(60);
        setCompanyData(res.data.data.company)
      }
    } catch {
      toast.error("Resend failed.");
    }
  };

  useEffect(() => {
    if (resendCooldown > 0) {
      const timer = setTimeout(() => setResendCooldown(resendCooldown - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [resendCooldown]);

  const submitOtp = async (e) => {
    e.preventDefault();
    const otpCode = otp.join("");
    if (otpCode.length !== 6) {
      toast.error("Enter the 6-digit OTP.");
      return;
    }
    setIsLoading(true);
    try {
      const res = await ApiService.request({
        method: "POST",
        url: "/company/verifyOTP",
        data: { otp: otpCode, company_id: companyData?._id, verify_for: "forgot" },
      });
      if (res.data.status) {
        toast.success("OTP verified.");
        setStep(3);
      } else {
        toast.error("Invalid OTP.");
      }
    } catch {
      toast.error("Verification failed.");
    }
    setIsLoading(false);
  };

  const submitNewPassword = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match.");
      return;
    }
    setIsLoading(true);
    try {
      const otpCode = otp.join("");
      if (otpCode.length !== 6) {
        toast.error("Enter the 6-digit OTP.");
        return;
      }
      const res = await ApiService.request({
        method: "POST",
        url: "/company/resetPassword",
        data: { company_id: companyData?._id, otp:otpCode , password: newPassword, confirm_password: confirmPassword },
      });
      if (res.data.status) {
        toast.success("Password reset successful.");
        setStep(4);
      }
    } catch {
      toast.error("Reset failed.");
    }
    setIsLoading(false);
  };

  const StepIndicator = ({ num, active, label }) => (
    <div className="d-flex align-items-center">
      <div
        className={`rounded-circle d-flex align-items-center justify-content-center fw-bold ${
          active ? "bg-dark text-white" : "bg-light text-muted"
        }`}
        style={{ width: "30px", height: "30px", fontSize: "14px" }}
      >
        {num}
      </div>
      <span className="ms-2 sofia-font">{label}</span>
    </div>
  );
 const { t, i18n } = useTranslation();
      const isRTL = i18n.language === 'ar';
  return (
<AuthGuard>
  <AnimatePresence mode="wait">
    <motion.div
      key={`forgot-${step}`}
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -50 }}
      transition={{ duration: 0.5 }}
      className="inter-font main-bg min-vh-100 d-flex flex-column justify-content-center align-items-center px-3"
      style={{ direction: isRTL ? "rtl" : "ltr" }}
    >
      <div
        className="text-center mt-5 pt-5 px-3 w-100"
        style={{ maxWidth: "816px" }}
      >
        <Link
          to={"/"}
          className="inter-font position-absolute top-0"
          style={{ [isRTL ? "right" : "left"]: "0", marginTop: "1rem", [isRTL ? "marginRight" : "marginLeft"]: "1rem" }}
        >
          <img
            src={logo}
            alt="Logo"
            style={{ height: 50, maxWidth: "100%" }}
          />
          <div className="left-strip" style={{ [isRTL ? "marginRight" : "marginLeft"]: "1%", paddingTop: "5px" }}>
            {[...Array(25)].map((_, i) => (
              <img
                key={i}
                src={decoration}
                alt="Decoration"
                className="strip-icon"
              />
            ))}
          </div>
        </Link>

        {step === 1 && (
          <>
            <h2
              className="fw-bold mb-3"
              style={{ fontSize: "40px", fontWeight: 700 }}
            >
              {t("c_ff_text9")} {/* Forgot Password? */}
            </h2>
            <p
              className="sofia-font mb-5"
              style={{ color: "#929292", fontSize: "22px" }}
            >
              {t("c_ff_text64")} {/* Enter your email address and we'll send you a link to reset your password. */}
            </p>

            <Form onSubmit={submitEmail}>
              <Form.Group
                className="mb-5"
                style={{ maxWidth: "557px", width: "100%", margin: "0 auto" }}
              >
                <Form.Control
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder={t("c_ff_text3")}
                  className="py-3 rounded-3 sofia-font inp-login w-100"
                  required
                  dir="ltr"
                  style={{ textAlign: isRTL ? "right" : "left" }}
                />
              </Form.Group>
              <Button
                type="submit"
                className="w-100 border-0"
                style={{
                  backgroundColor: "#E26A52",
                  padding: "10px 0",
                  fontWeight: "500",
                  fontSize: "15px",
                  maxWidth: "230px",
                }}
              >
                {isLoading ? t("c_ff_text20") : t("c_ff_text6")} {/* Resetting... / Send Reset Link */}
              </Button>
              <div className="mt-3">
                <Button
                  variant="link"
                  style={{
                    color: "#000",
                    textDecoration: "none",
                    fontSize: "18px",
                    fontWeight: 500,
                  }}
                  onClick={() => navigate("/company/login")}
                >
                  {t("c_ff_text7")} {/* Back to Sign In */}
                </Button>
              </div>
            </Form>
          </>
        )}

        {step === 2 && (
          <>
            <img
              src={mail}
              alt="Step 1"
              style={{
                height: "116px",
                width: "104px",
                objectFit: "contain",
              }}
              className="mb-5"
            />

            <h2 className="fw-bold mb-4">{t("c_ff_text9")}</h2> {/* Password Reset */}

            {/* Description */}
            <p className="sofia-font mb-4" style={{ color: "#929292" }}>
              {t("c_ff_text10")} {/* We sent a code to */}{" "}
              <span style={{ color: "#000", fontWeight: "500" }}>
                {email}
              </span>
            </p>
            <Form onSubmit={submitOtp}>
              <div className="d-flex gap-2 flex-wrap justify-content-center mb-5">
                {otp.map((digit, i) => (
                  <Form.Control
                    key={i}
                    type="text"
                    maxLength="1"
                    className="text-center fs-4 forgot-otp"
                    style={{ width: "70px", height: "70px" }}
                    onChange={(e) => handleOtpChange(e, i)}
                    onKeyDown={(e) => handleOtpKeyDown(e, i)}
                    ref={(el) => (inputsRef.current[i] = el)}
                    value={digit}
                    dir="ltr"
                  />
                ))}
              </div>
              <Button
                type="submit"
                className="border-0 w-100"
                style={{
                  backgroundColor: "#E26A52",
                  padding: "10px 0",
                  fontWeight: "500",
                  fontSize: "15px",
                  maxWidth: "230px",
                }}
              >
                {isLoading ? t("processing") : t("c_continue")} {/* Processing... / Continue */}
              </Button>
            </Form>
            <p className="mt-3" style={{ fontSize: "14px", color: "black" }}>
              {t("c_ff_text11")} {/* Didn't receive the email? */}{" "}
              <Button
                variant="link"
                onClick={resendOtp}
                disabled={resendCooldown > 0}
                style={{
                  color: "#E46A56",
                  padding: 0,
                  textDecoration: "underline",
                  background: "none",
                }}
              >
                {resendCooldown > 0
                  ? `${t("resend_in")} ${resendCooldown}s`
                  : t("c_ff_text12")} {/* Resend in / Click to resend */}
              </Button>
            </p>
          </>
        )}

        {step === 3 && (
          <>
            <img
              src={lock}
              alt="Step 1"
              style={{
                height: "116px",
                width: "104px",
                objectFit: "contain",
              }}
              className="mb-5"
            />

            <h2 className="fw-bold">{t("c_ff_text13")}</h2> {/* Set a New Password */}
            <p className="sofia-font mb-4" style={{ color: "#929292" }}>
              {t("c_ff_text14")} {/* Enter a new password for your account. */}
            </p>
            <Form
              onSubmit={submitNewPassword}
              style={{ maxWidth: "557px", width: "100%", margin: "0 auto" }}
            >
              <Form.Group className="mb-3 position-relative">
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  placeholder={t("c_ff_text16")}
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                  dir="ltr"
                  style={{ textAlign: isRTL ? "right" : "left" }}
                />
                <span
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: "absolute",
                    [isRTL ? "left" : "right"]: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                  }}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </Form.Group>
              <Form.Group className="mb-5 position-relative">
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  placeholder={t("c_ff_text18")} 
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                  dir="ltr"
                  style={{ textAlign: isRTL ? "right" : "left" }}
                />
              </Form.Group>
              <Button
                type="submit"
                className="w-100 border-0"
                style={{
                  backgroundColor: "#E26A52",
                  padding: "10px 0",
                  fontWeight: "500",
                  fontSize: "15px",
                  maxWidth: "230px",
                }}
              >
                {isLoading ? t("c_ff_text20") : t("c_ff_text19")} {/* Resetting... / Set New Password */}
              </Button>
            </Form>
          </>
        )}

        {step === 4 && (
          <>
            <div style={{ position: "relative", display: "inline-block" }}>
              {/* Star image */}
              <img
                src={star}
                alt="Star"
                style={{
                  height: "116px",
                  width: "104px",
                  objectFit: "contain",
                  display: "block"
                }}
              />

              {/* Checkmark image */}
              <img
                src={right}
                alt="Check"
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  height: "30px",
                  width: "42x",
                  objectFit: "contain",
                }}
              />
            </div>

            <h2 className="fw-bold mb-4">{t("c_ff_text21")}</h2> {/* Password Reset Successfully */}
            <p
              className="sofia-font mb-5"
              style={{
                color: "#787878",
                maxWidth: "484px",
                width: "100%",
                margin: "0 auto",
              }}
            >
              {t("c_ff_text22")} {/* Your password has been updated. you can now sign in with your new password. */}
            </p>
            <Button
              onClick={() => navigate("/company/login")}
              type="submit"
              className="w-100 border-0"
              style={{
                backgroundColor: "#E26A52",
                padding: "10px 0",
                fontWeight: "500",
                fontSize: "15px",
                maxWidth: "230px",
              }}
            >
              {t("c_ff_text23")} {/* Sign in your account */}
            </Button>
          </>
        )}
      </div>
    </motion.div>
  </AnimatePresence>
</AuthGuard>
  );
};

export default ForgotPassword;
